function observeModals() {
  const observer = new MutationObserver(() => {
    gk_modal.load();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

let gk_modal = {
  scrollY: 0,

  load() {
    const modalButtons = document.querySelectorAll(".js-btn-modal");

    modalButtons.forEach((button) => {
      if (!button.dataset.modalLoaded) {
        button.dataset.modalLoaded = "true";

        button.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          const modalId = this.getAttribute("data-id");
          if (!modalId) return;

          const modal = document.getElementById(modalId);

          if (modal) {
            gk_modal.scrollY = window.scrollY;

            document.body.style.top = `-${gk_modal.scrollY}px`;
            document.body.classList.add("no-scroll");

            modal.classList.add("is-open");
          }
        });
      }
    });

    const closeButtons = document.querySelectorAll(".js-close-btn");
    closeButtons.forEach((btn) => {
      if (!btn.dataset.modalLoaded) {
        btn.dataset.modalLoaded = "true";
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          gk_modal.closeModals();
        });
      }
    });

    const modals = document.querySelectorAll(".Modal");
    modals.forEach((modal) => {
      // Portail vers <body> : sort la modale de tout ancêtre qui crée un
      // contexte d'empilement ou un bloc conteneur (wrappers reveal, sections
      // thémées…). Sinon son fond plein écran reste piégé dans la section et une
      // section voisine se peint par-dessus (effet "écran coupé en 2"/bande claire).
      // Idempotent : une fois enfant direct de <body>, on n'y touche plus.
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      if (!modal.dataset.modalLoaded) {
        modal.dataset.modalLoaded = "true";

        modal.addEventListener("click", function (e) {
          if (!e.target.closest(".Modal-content")) {
            gk_modal.closeModals();
          }
        });
      }
    });

    if (!document.body.dataset.modalEscapeLoaded) {
      document.body.dataset.modalEscapeLoaded = "true";

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          gk_modal.closeModals();
        }
      });
    }
  },

  closeModals() {
    const modals = document.querySelectorAll(".Modal");

    modals.forEach((modal) => modal.classList.remove("is-open"));

    const scrollY = document.body.style.top;

    document.body.classList.remove("no-scroll");
    document.body.style.top = "";

    window.scrollTo({
      top: parseInt(scrollY || "0") * -1,
      behavior: "instant",
    });
  },
};

observeModals();
export default gk_modal;
